"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultAnimationDurationFromIntervalSeconds = void 0;
var react_1 = __importDefault(require("react"));
var AnimationWrapper_1 = __importStar(require("./AnimationWrapper"));
var TimerQueueWrapper_1 = __importDefault(require("./TimerQueueWrapper"));
var config_1 = require("./config");
exports.getDefaultAnimationDurationFromIntervalSeconds = function (_a) {
    var intervalSeconds = _a.intervalSeconds, animationDuration = _a.animationDuration;
    return function (index) {
        var res = 0;
        if (typeof animationDuration === 'undefined') {
            res = Array.isArray(intervalSeconds) ?
                intervalSeconds[index] :
                (intervalSeconds || config_1.defaultIntervalSeconds);
        }
        else if (Array.isArray(animationDuration)) {
            return animationDuration[index];
        }
        else {
            return animationDuration;
        }
        return res;
    };
};
var AnimatedTimerQueueWrapper = function (props) {
    var _a = props.marqueeLeftDuration, marqueeLeftDuration = _a === void 0 ? AnimationWrapper_1.defaultMarqueeLeftTime : _a;
    var animationDuration = exports.getDefaultAnimationDurationFromIntervalSeconds(props);
    // const Children = React.Children.map(props.children, (child) => (
    //   <AnimationWrapper 
    //     {...props}
    //     animationDuration={animationDuration}
    //   >
    //     {child}
    //   </AnimationWrapper>
    // ));
    // console.log(marqueeLeftDuration);
    return (react_1.default.createElement(TimerQueueWrapper_1.default, __assign({}, props, { intervalSeconds: Array.isArray(props.intervalSeconds) ? props.intervalSeconds.map(function (i) { return i + marqueeLeftDuration; }) : props.intervalSeconds }), props.children.map(function (child, i) { return (react_1.default.createElement(AnimationWrapper_1.default, __assign({}, props, { key: i, marqueeLeftDuration: marqueeLeftDuration, animationDuration: animationDuration(i) }), child)); })));
};
exports.default = AnimatedTimerQueueWrapper;
